import { UserRepo } from './repo'
import { Network } from '../../utils/network'
import { Events } from '../../utils/servicesEvents'
import { login } from './use-cases/login'
import { Formatter } from './formatter'
import { saveDeviceToken } from './use-cases/saveDeviceToken'
import { register } from './use-cases/register'
import { Commons } from '../../utils/commons'
import urls from './raws/urls.json'
import { updateUserData } from './use-cases/updateUserData'
import { getUserData } from './use-cases/getUserData'

class UserController {
  static async refreshData(data) {
    return
  }

  static async login(data) {
    const userConnected = await UserController.isConnected()
    if (userConnected) Events.dispatchEvent('logout_requested')
    const res = await login(data, urls, Formatter, Network)
    if (!res.success) return Events.dispatchEvent('login_failed', res)
    await UserController.saveUser(res.user)
    Events.dispatchEvent('login_done', res.user)
  }

  static async updateUserData(data) {
    const userConnected = await UserController.isConnected()
    if (!userConnected) {
      Events.dispatchEvent('logout_requested')
      return
    }
    const res = await updateUserData(data, urls, Formatter, Network)
    if (!res.success) {
      Events.dispatchEvent('user_not_updated', res)
      return
    }
    await UserController.saveUser(res.user)
    Events.dispatchEvent('user_data_updated', res.user)
  }

  static async register(data) {
    const userConnected = await UserController.isConnected()
    if (userConnected) Events.dispatchEvent('logout_requested')
    const res = await register(data, urls, Formatter, Network)
    if (!res.success) return Events.dispatchEvent('registration_failed', res)
    await UserController.saveUser(res.user)
    Events.dispatchEvent('registration_done', res.user)
  }

  static async saveUserDeviceToken(token = null) {
    const userConnected = await UserController.isConnected()
    console.log('userConnected', userConnected, token)
    if (!userConnected) Events.dispatchEvent('device_token_saving_failed')
    const res = await saveDeviceToken(token, urls, Network)
    if (!res.success) Events.dispatchEvent('device_token_saving_failed')
    else Events.dispatchEvent('device_token_saved')
  }

  static async isConnected() {
    const user = await UserController.getUserData()
    return !!user
  }

  static async getUserData() {
    const db = await UserRepo.getDb()
    if (!db) return null
    const user = await db.get()
    return Formatter.buildUserEntity(user)
  }

  static async saveUser(user) {
    const db = await UserRepo.getDb()
    if (!db) return Events.dispatchEvent('failed_to_save_user')
    await db.clean()
    await db.save(user)
    Events.dispatchEvent('user_updated')
  }

  static async initListeners() {
    Events.handleEvent('login_requested', async data => {
      UserController.login(data)
    })
    Events.handleEvent('update_user_data', async data => {
      UserController.updateUserData(data)
    })
    Events.handleEvent('user_preferences_updated', async data => {
      const user = await UserController.getUserData()
      if (!user) return
      const oldMeta = user.getMetaData()?.metadata || {}
      const updates = {
        metadata: {
          ...oldMeta,
          xbetAccountId: data.xbetAccountId || oldMeta.xbetAccountId,
          betwinnerAccountId: data.betwinnerAccountId || oldMeta.betwinnerAccountId,
          melbetAccountId: data.melbetAccountId || oldMeta.melbetAccountId,
          eightStarzAccountId: data.eightStarzAccountId || oldMeta.eightStarzAccountId,
          oneWinAccountId: data.oneWinAccountId || oldMeta.oneWinAccountId,
        },
      }
      UserController.updateUserData(updates)
    })
    Events.handleEvent('registration_requested', async data => {
      UserController.register(data)
    })
    Events.handleEvent('reset_user_password', async data => {
      let res = await getUserData(
        { email: data.email },
        urls,
        Formatter,
        Network,
      )
      if (!res.success) {
        Events.dispatchEvent('password_not_reset_failed', {
          userNotFound: true,
        })
        Events.dispatchEvent('toast_notification', {
          title: "Vous n'êtes pas inscrit",
          body: "Vous n'êtes pas inscrit sur Kingrecharge",
        })
        return
      }
      res = await updateUserData(
        { id: res.user.reference, password: data.password },
        urls,
        Formatter,
        Network,
      )
      if (!res.success) {
        Events.dispatchEvent('password_not_reset_failed', res)
        return
      }
      Events.dispatchEvent('password_reset_done', res)
    })
    Events.handleEvent(
      'request:userData',
      async ({ responseId, userReference }) => {
        let user
        if (userReference) {
          const res = await getUserData(
            { reference: userReference },
            urls,
            Formatter,
            Network,
          )
          user = res.user || null
        } else user = await UserController.getUserData()
        Events.dispatchEvent(responseId, Commons.changeToJson(user))
      },
    )
    Events.handleEvent('device_token_available', async ({ deviceToken }) => {
      UserController.saveUserDeviceToken(deviceToken)
    })
    Events.handleEvent('logout_requested', async () => {
      const db = await UserRepo.getDb()
      await db.clean()
      Events.dispatchEvent('user_updated')
      Events.dispatchEvent('logout_done')
    })
    Events.handleEvent('clean_all_data_requested', async () => {
      const db = await UserRepo.getDb()
      await db.clean()
      Events.dispatchEvent('user_updated')
      Events.dispatchEvent('logout_done')
    })
  }
}

export { UserController }
